import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

// login
export const create_judge0_coding_user_action = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(config.common.testQuestion, data);
    if (response.status) {
      let data = response?.data;
      if (data) return data;
    } else {
      return false;
    }
  } catch (e) {
    showWarningMessage(e?.msg);
    return e;
  }
};

export const get_judge0_coding_user_action = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      config.common.getTestQuestion.replace(":id", id)
    );
    if (response.status) {
      let data = response?.data;
      if (data) return data;
    } else {
      return false;
    }
  } catch (e) {
    showWarningMessage(e?.msg);
    return e;
  }
};

export const create_submit_judge0_coding_user_action = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(
      config.common.createTestQuestionSubmission,
      data
    );
    if (response.status) {
      let data = response?.data;
      if (data) return data;
    } else {
      return false;
    }
  } catch (e) {
    showWarningMessage(e?.msg);
    return e;
  }
};

export const get_submit_judge0_coding_user_action = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        config.common.getTestQuestionSubmission,
        data
      );
      if (response.status) {
        let data = response?.data;
        if (data) return data;
      } else {
        return false;
      }
    } catch (e) {
      showWarningMessage(e?.msg);
      return e;
    }
  };


  export const compile_judge0_coding_user_action = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        config.common.compileTestQuestion,
        data
      );
      if (response.status) {
        let data = response?.data;
        if (data) return data;
      } else {
        return false;
      }
    } catch (e) {
      showWarningMessage(e?.msg);
      return e;
    }
  };